import { render, staticRenderFns } from "./elements.vue?vue&type=template&id=7c87218d&scoped=true"
import script from "./elements.vue?vue&type=script&lang=js"
export * from "./elements.vue?vue&type=script&lang=js"
import style0 from "./elements.vue?vue&type=style&index=0&id=7c87218d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87218d",
  null
  
)

export default component.exports